import { Point } from "./Point";
import { IVector } from "./IVector";

export class Vector {
    constructor(public from: Point = new Point(), public to: Point = new Point()) { }

    get difference() {
        return this.to.subtract(this.from);
    }

    move(difference: Point): Vector {
        return new Vector(this.from.add(difference), this.to.add(difference));
    }

    floor(): Vector {
        return new Vector(
            this.from.floor(),
            this.to.floor(),
        );
    }

    static from(source: IVector | Point) {
        if (!source) {
            return null;
        }
        return (source instanceof Point)
            ? new Vector(new Point(0, 0), source)
            : new Vector(Point.from(source.from), Point.from(source.to));
    }

    clone(): Vector {
        return new Vector(
            this.from.clone(),
            this.to.clone()
        );
    }
    
    static to(source: Vector): IVector {
        if (!source) {
            return null;
        }
        return {
            from: source.from,
            to: source.to,
        };
    }
}
